import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Fab from '@material-ui/core/Fab';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';

const fabStyle = {
  position: 'fixed',
  right: 24,
  bottom: 24,
  zIndex: 1300
};

const iconStyle = { verticalAlign: 'middle', marginRight: 8 };

const SupportFab = () => {
  const tenant = useSelector(state => state.tenant);
  const [open, setOpen] = useState(false);

  const phone = tenant.companyContactPhone || null;
  const email = tenant.companyContactEmail || null;

  if (!phone && !email) {
    return null;
  }

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Tooltip title="Support" placement="left">
        <Fab
          color="secondary"
          aria-label="support"
          onClick={handleOpen}
          style={fabStyle}
        >
          <ContactSupportIcon />
        </Fab>
      </Tooltip>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="support-dialog-title"
      >
        <DialogTitle id="support-dialog-title">Support</DialogTitle>
        <DialogContent>
          {phone ? (
            <Typography variant="body1" gutterBottom>
              <PhoneIcon style={iconStyle} />
              <a href={`tel:${phone}`}>{phone}</a>
            </Typography>
          ) : null}
          {email ? (
            <Typography variant="body1">
              <EmailIcon style={iconStyle} />
              <a href={`mailto:${email}`}>{email}</a>
            </Typography>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Fermer
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SupportFab;
